export enum PluginNameEnum {
  Seiue = 'seiue',
  Record = 'record',
  Qymail163 = 'qymail163',
  Oa = 'oa',
  Speed = 'speed',
  Seeyou = 'seeyou',
  Qywx = 'qywx',
  Oidc = 'oidc',
  Nocobase = 'nocobase',
}
